// libs
import React, { memo } from 'react';

interface UserProps {
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string;
  className?: string;
}

function User({
  width = 24,
  height = 24,
  fill = '#001325',
  fillOpacity = '0.64',
  className = '',
}: UserProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity={fillOpacity}>
        <path
          d="M18.9001 21.5001C19.2867 21.5001 19.6001 21.1867 19.6001 20.8001C19.6001 20.4135 19.2867 20.1001 18.9001 20.1001C18.5135 20.1001 18.2001 20.4135 18.2001 20.8001C18.2001 21.1867 18.5135 21.5001 18.9001 21.5001Z"
          fill={fill}
        />
        <path
          d="M15.9001 21.5001C16.2867 21.5001 16.6001 21.1867 16.6001 20.8001C16.6001 20.4135 16.2867 20.1001 15.9001 20.1001C15.5135 20.1001 15.2001 20.4135 15.2001 20.8001C15.2001 21.1867 15.5135 21.5001 15.9001 21.5001Z"
          fill={fill}
        />
        <path
          d="M12.9001 21.5001C13.2867 21.5001 13.6001 21.1867 13.6001 20.8001C13.6001 20.4135 13.2867 20.1001 12.9001 20.1001C12.5135 20.1001 12.2001 20.4135 12.2001 20.8001C12.2001 21.1867 12.5135 21.5001 12.9001 21.5001Z"
          fill={fill}
        />
        <path
          d="M12 4C12.7 4 13.3 4.2 13.8 4.7C14.3 5.2 14.5 5.9 14.5 6.6V6.7C14.5 7.4 14.3 8.2 13.8 8.7C12.8 9.7 11.2 9.7 10.2 8.7C9.70004 8.2 9.40004 7.5 9.40004 6.8V6.7C9.30004 5.3 10.3 4.1 11.7 4C11.8 4 11.9 4 12 4ZM12 2.5C9.80004 2.5 8.00004 4.3 8.00004 6.5C8.00004 6.6 8.00004 6.6 8.00004 6.7V6.8C7.90004 9 9.60004 10.9 11.8 11C11.9 11 11.9 11 12 11C13.1 11 14.1 10.6 14.9 9.8C15.7 9 16.1 7.9 16 6.8V6.6C16 5.5 15.6 4.4 14.8 3.6C14.1 2.9 13 2.5 12 2.5Z"
          fill={fill}
        />
        <path
          d="M9.80005 21.5002H5.80005C5.40005 21.5002 5.00005 21.3002 4.70005 21.0002C4.40005 20.7002 4.30005 20.2002 4.40005 19.8002C5.00005 15.4002 9.00005 12.4002 13.4 13.0002C16.2 13.4002 18.6 15.2002 19.7 17.8002C19.8 18.2002 19.6 18.6002 19.2 18.8002C18.8 18.9002 18.4 18.8002 18.3 18.4002C17 15.1002 13.2 13.4002 9.90005 14.7002C7.70005 15.6002 6.10005 17.6002 5.80005 20.0002H9.80005C10.2 20.0002 10.6 20.3002 10.6 20.8002C10.6 21.3002 10.2 21.5002 9.80005 21.5002Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default memo(User);
